import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'

const JackpotListPage = () => {
	return (
		<div className="main-content jackpot-list-page">
			<GamificationBlock
				domId={WIDGETS.jackpot.domId}
				url={WIDGETS.jackpot.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default JackpotListPage
